var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationProfileNormalstate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9451 6.35775C13.9451 4.93679 13.3662 3.57402 12.3356 2.56925C11.3051 1.56448 9.90737 1 8.44997 1C6.99257 1 5.59487 1.56448 4.56433 2.56925C3.53379 3.57402 2.95484 4.93679 2.95484 6.35775C2.95484 8.69835 2.56959 10.4129 2.08761 11.6421C1.72422 12.5688 2.58521 14.3944 3.58064 14.3944H13.3193C14.3147 14.3944 15.1757 12.5688 14.8123 11.6421C14.3304 10.4129 13.9451 8.69835 13.9451 6.35775Z",
    stroke: "#747474",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2319 16.2181C11.2319 17.7636 9.99551 19 8.45 19C6.90449 19 5.66809 17.7636 5.66809 16.2181H11.2319Z",
    stroke: "#747474",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationProfileNormalstate);
export default __webpack_public_path__ + "static/media/Notification _ Profile _ normal state.6e45b87c7782b2537e18c1e9f605472c.svg";
export { ForwardRef as ReactComponent };